/**
 * @file Map-marker-tabs.tsx
 * @module MapMarkerTabs
 * @description Cilņu navigācijas komponente marķiera rediģēšanas formā.
 *              Nodrošina pārslēgšanos starp "Lineārā reference" un "Koordinātas"
 *              cilnēm, kā arī iekļauj pamata formas (adrese, apvedceļa opcijas) sadaļu.
 */
import { Tabs } from "antd";
import { MapMarkerCoordForm } from "./form/Map-marker-coord-form";
import { MapMarkerLinearRefForm } from "./form/Map-marker-linear-ref-form";
import { useContext } from "react";
import { findError, NewFeatureListContext } from "./Map-marker-list-wrapper";
import { MapMarkerBaseForm } from "./form/Map-marker-base-form";

export const MapMarkerTabs = () => {
	const { sticky, errors, selectedItem } = useContext(NewFeatureListContext);

	const error = findError(selectedItem, errors);

	return (
		<div className="flex flex-col justify-between">
			<Tabs
				defaultActiveKey={sticky ? "1" : "2"}
				destroyInactiveTabPane={true}
				className="!font-medium"
				items={[
					{
						label: <p className={`${error && error.error === "measure_error" && "text-red-500"}`}>Lineārā reference</p>,
						key: "1",
						children: <MapMarkerLinearRefForm />,
					},
					{
						label: <p className={`${error && (error.error === "point_error" || error.error === "general_error") && "text-red-500"}`}>Koordinātas</p>,
						key: "2",
						children: <MapMarkerCoordForm />,
					},
				]}
			/>
			<MapMarkerBaseForm />
		</div>
	);
};
